import {IController} from "angular";
import * as angular from "angular";

export class ContractRowActionButtonComponent implements IController {

  contract: any;
  onViewContractClicked: Function;
  onEditContractCarriers: Function;
  onContractDeleted: Function;
  onSetContractAsDefault: Function;

  constructor() {
  }

  onOpen($mdMenu, event) {
    $mdMenu.open(event);
  }
}

angular
  .module('bringoz.admin.contracts')
  .component('contractRowActionButton', {
    bindings: {
      contract: '<',
      onViewContractClicked: '&',
      onEditContractCarriers: '&',
      onContractDeleted: '&',
      onSetContractAsDefault: '&'
    },
    template: require('./contract-row-action-button.html').default,
    controller: ContractRowActionButtonComponent
  });
